import decodeHtmlEntities from './decodeHtmlEntities';
import encodeHtmlEntities from './encodeHtmlEntities';

const addTargetBlank = (str: string) => {
  // <a로 시작하고 target 속성이 없는 태그를 찾아서 target="_blank"를 추가
  return str.replace(/<a(?![^>]*target=)(.*?)>/gi, '<a$1 target="_blank">');
};

const processHref = (html: string) => {
  return html.replace(/href="(.*?)"/g, (match, p1) => {
    return `href="${encodeHtmlEntities(p1)}"`;
  });
};

export const convertHTML = (html: string) => {
  let str = html;

  str = decodeHtmlEntities(str);

  // 레거시 데이터가 target을 포함해서 오고있음
  // href또한 디코딩되지 않은 형태로 오고있음
  str = addTargetBlank(str);
  str = processHref(str);

  return str;
};
